export const logout = () => {
  const token = sessionStorage.getItem("token");
  const provider = sessionStorage.getItem("provider");

  if (token) {
    sessionStorage.removeItem("token");
  }

  if (provider) {
    sessionStorage.removeItem("provider");
  }

  return true;
};
